import { axiosDefault } from '@/core/utils';

const claimDailyReward = async () => {
	const url = `/tg/user/daily/rewards`;
	const response = await axiosDefault.put(url, null);
	return response.data;
};

const claimExtraReward = async (rewardId: string) => {
	const url = `/tg/user/other/reward/${rewardId}/collect`;
	const response = await axiosDefault.put(url, null);
	return {
		currentCoins: response.data.currentCoins,
		currentDiamonds: response.data.currentDiamonds,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
		data: response.data.data,
	};
};

export const RewardService = {
	claimDailyReward,
	claimExtraReward,
};
